<template>
    <div id="Container_GroupAppointmentList">
        <b-row>
            <b-col md="12">
                <MdTitle v-bind:Text="titleStr" />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12" v-show="false">
                <MdLookupMultiSelect
                    ref="lookupPatientRef"
                    v-bind:Label="$tc('Shared.Patient',2)"
                    v-bind:ModelCode="PatientCodeModel"
                    v-bind:RefCode="'patientcode'"
                    v-bind:Api="'Patients'"
                    v-bind:FieldCode="'patientcode'"
                    v-bind:FieldDescription="'firstname'"
                    :SearchTitle="$tc('Shared.Patient',2)"
                    :GetValues="getValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :SearchFieldCode="'PatientCode'"
                    :AuxFields="AuxFields"
                    :FieldsDate="fieldsDate"
                    :ServerSidePagination="true"
                    v-bind:Fields="BaseFields"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdButton
                    v-bind:Label="$t('Shared.Add')"
                    v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-on:click="AddPatients"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Name="'btn_add_blocking_time'"
                >
                </MdButton>
            </b-col>
            <b-col md="9" lg="9" sm="12">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            v-model="parameter.SearchCriteria"
                            @keyup.enter="GetGroupApptPatients"
                        />

                        <div class="input-group-append">
                            <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="GetGroupApptPatients"
                            >
                            </MdButton>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="mt-3 text-right">
                    <button
                        v-on:click="GetGroupApptPatients"
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        id="btnsearchinput"
                    >
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="12" md="12" sm="12" class="mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />

                <b-row>
                    <b-col md="12">
                        <MdEditableGrid
                            :ref="'editableGrid'"
                            :columns="columnsDetail"
                            :rows="items"
                            :showMessageIsEmpty="ShowMessageIsEmpty"
                            :serverSidePagination="true"
                            :showAdd="false"
                            :showDelete="true"
                            :showSelectAll="true"
                            :showSearch="false"
                            :totalRows="totalDetailRows"
                            :currentPage="currentDetailPage"
                            :perPage="perDetailPage"
                            :pageOptions="pageOptions"
                            :pageChanged="pageDetailChanged"
                            :perPageFunction="PerPageDetailFunction"
                            :deleteActionButton="deleteDetailActionButton"
                            :dataKey="'activityID'"
                            @select-row="onRowDetailSelected">
                        </MdEditableGrid>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="DiscardChanges"/>
            <b-dropdown
                id="dropdown-dropup"
                dropup
                :text="$tc('Shared.ActionsTxt', 2)"
                variant="primary"
                class="m-2"
            >
                <b-dropdown-item href="#" v-if="showUp" v-on:click="ShowUpAppt('T')">
                    {{ $t('Shared.ShowUp') }}
                </b-dropdown-item>
                <b-dropdown-item href="#" v-if="uShowUp" v-on:click="ShowUpAppt('F')">
                    {{ $t('Shared.uShowUp') }}
                </b-dropdown-item>

            </b-dropdown>
        </div>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import SchedulerService from '@/services/schedulers.service'
import AppointmentService from '@/services/appointment.service';
import Utils from '@/common/utils';

export default {
    name: 'ScheduleGroupAppointmentPatientsList',
    mixins: [DBFunctions, ShowMessage],

    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                btnvisible: false,
                ItemsList: [],
                favButtonAtion: false
            },

            columnsDetail: [
            {
              key: 'patientName',
              label: this.$t('Shared.PatientName'),
              editable: false
            },
            {
              key: 'patientCode',
              label: this.$t('Shared.PatientCode'),
              editable: false
            },
            {
              key: 'showedUp',
              label: this.$t('schedule_sample.showedUp'),
              editable: false
            },
          ],
            pageOptions: [5,10,20,30,40,50],
            totalDetailRows: 0,
            currentDetailPage: 1,
            perDetailPage: 10,
            filter: null,
            filterOn: [],
            items: [],
            isReadOnly: false,
            ShowMessageIsEmpty: '',
            parameter: {
                SearchCriteria: '',
                ActivityID: null,
                PageNumber: 1,
                PageSize: 0,
            },
            deleteDetailActionButton: {
                visible: true,
                handler: this.deleteItem
            },
            detailSelected: [],
            PatientCodeModel: [],
            AuxFields:['lastname'],
            fieldsDate:['dob'],
            BaseFields:[
                { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
                { key: 'lastname', sortable: true, label: this.$t('Shared.LastName')},
                { key: 'patientcode', sortable: true, label: this.$t('Shared.Code')},
                { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone')},
                { key: 'address1', sortable: true, label: this.$t('Shared.Address1')},
                { key: 'city', sortable: true, label: this.$t('Shared.City')},
                { key: 'state', sortable: true, label: this.$t('Shared.State')},
                { key: 'country', sortable: true, label: this.$t('Shared.Country')},
                { key: 'zip', sortable: true, label: this.$t('Shared.Zip')}
            ],
            transDateStr: '',
            appTypeStr: '',
            therapistStr: '',
            titleStr: `${this.$t('Shared.groupAppointments')}`,
            showUp: false,
            uShowUp: false,
        };
    },

    computed: {
        editableGrid() {
            return this.$refs.editableGrid;
        }
    },

    methods: {

        ShowUpAppt(opt) {
            let param = {};
            let aIdList = [];

            if (this.detailSelected && this.detailSelected.length == 1) {
                param = {
                    ActivityIdList: this.detailSelected[0].activityID,
                    State: opt,
                    Action: opt == 'T' ? 'Show Up' : 'Undo Show Up'
                };
            } else if (this.detailSelected && this.detailSelected.length > 1) {
                this.detailSelected.forEach(item => {
                    aIdList.push(item.activityID);
                });
                param = {
                    ActivityIdList: aIdList.toString(),
                    State: opt,
                    Action: opt == 'T' ? 'Show Up' : 'Undo Show Up'
                };
            }

            AppointmentService.ShowUp(param)
                .then(async response => {
                    if (response.status == '200') {
                        if (opt == 'T') {
                            this.$bvToast.toast(this.$t('Appointments.showUpMsg'), {
                                title: this.$t('Msg.Info'),
                                autoHideDelay: 5000,
                                variant: 'success'
                            });
                        } else {
                            this.$bvToast.toast(this.$t('Appointments.uShowUpMsg'), {
                                title: this.$t('Msg.Info'),
                                autoHideDelay: 5000,
                                variant: 'success'
                            });
                        }
                        this.GetGroupApptPatients();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getValues: async function (value) {
            this.PatientCodeModel = value
            let pCodes = value.join(',')
            await this.GroupAppointmentAddPatients(pCodes)
            await this.GetGroupApptPatients();
        },

        deleteItem(item) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteAllRecord'), {
                    title: this.$tc('Shared.DelRecord', 2),
                    okTitle: this.$t('Shared.TitleDeleteAll'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        if (item && item.length > 0) {
                        let activityIdList = []
                        item.forEach(el => {
                            const idsToRemove =
                            this.detailSelected.length > 0
                                ? this.detailSelected.map(row => row.activityID)
                                : [el.activityID];

                            this.items = this.items.filter(row => !idsToRemove.includes(row.activityID));
                            this.detailSelected = [];
                            activityIdList.push(el.activityID)
                        });
                        this.deletePatient(activityIdList.join(','))
                    } else {
                        const idsToRemove =
                        this.detailSelected.length > 0
                            ? this.detailSelected.map(row => row.activityID)
                            : [item.activityID];

                        this.items = this.items.filter(row => !idsToRemove.includes(row.activityID));
                        this.detailSelected = [];
                        this.deletePatient(item.activityID)
                    }
                    }
                });
        },


        async deletePatient(activityID) {
             let params = {
                'activityIdList': activityID,
            }
            await SchedulerService
                .GroupAppointmentDeletePatients(params)
                .then(response => {
                    if (response.status == '200') {
                        //
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        AddPatients() {
            this.PatientCodeModel = null
            this.$refs.lookupPatientRef.CallModalTable();
        },

        onRowDetailSelected(rows){
            this.detailSelected = rows;
            if (this.detailSelected && this.detailSelected.length == 1) {
                this.showUp = this.detailSelected[0].showedUp == 'F'  ? true : false;
                this.uShowUp = this.detailSelected[0].showedUp == 'T' ? true : false;
            } else if (this.detailSelected && this.detailSelected.length > 0) {
                this.showAllActions(true);
            } else {
                this.showAllActions(false);
            }
        },

        showAllActions(enabled) {
            this.showUp = enabled;
            this.uShowUp = enabled;
        },

        DiscardChanges() {
            this.$router.push({
              name: "ScheduleGroupAppointmentList"
            });
        },

        async GetGroupApptPatients() {
            this.parameter.PageSize = this.perDetailPage;
            this.parameter.PageNumber = this.currentDetailPage;
            this.parameter.ActivityID = this.$route.params.activityid
            await SchedulerService
                .getGroupAppointmentPatients(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.totalDetailRows = this.Header.TotalCount;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async GroupAppointmentAddPatients(patientCodeList) {
            let params = {
                'patientCodeList': patientCodeList,
                'groupCreationId': this.$route.params.activityid
            }
            await SchedulerService
                .GroupAppointmentAddPatients(params)
                .then(response => {
                    if (response.status == '200') {
                        //
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        onRowSelected() {},

        onFiltered() {},

        pageDetailChanged(page){
            this.currentDetailPage = page;
            this.GetGroupApptPatients();
        },

        PerPageDetailFunction(perpage){
            this.perDetailPage = perpage;
            this.currentDetailPage = 1;
            this.GetGroupApptPatients();
        },

        GetGroupAppt() {
            this.parameter.PageSize = 1;
            this.parameter.PageNumber = 1;
            this.parameter.GroupCreationId = this.$route.params.activityid
            SchedulerService
                .getGroupAppointments(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.transDateStr = ` - ${Utils.formatterDateToString(response.data[0].transDate)}`
                        this.appTypeStr = ` - ${response.data[0].activitytypename}`
                        this.therapistStr = ` - ${response.data[0].therapistName}`
                        this.titleStr = `${this.$t('Shared.groupAppointments')}${this.transDateStr}${this.appTypeStr}${this.therapistStr}`
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },
    },

    created() {
        this.GetGroupApptPatients();
        if (this.$route.params.activityid)
            this.GetGroupAppt()
    },

    mounted() {
        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;
        this.OptionsRightMenu.ItemsList = [];
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
    }
};
</script>
